import { useHubble } from '@seek/hubble';
import type { PageName, SolMetadata } from '@seek/sol-js';
import { useEffect, useState } from 'react';

import { useAppConfig } from 'src/components/App/useAppConfig';

const useHubbleTrackDisplayEvent = ({
  solMetadata,
  page,
  isFilteredOnNew = false,
}: {
  solMetadata: SolMetadata;
  page: PageName;
  isFilteredOnNew?: boolean;
}) => {
  const { environment } = useAppConfig();
  // Hubble Tracking
  const hubble = useHubble();
  const [tracked, setTracked] = useState(false);

  useEffect(() => {
    if (solMetadata && !tracked) {
      setTracked(true);
      const enhancedSolMetaData = {
        ...solMetadata,
        tags: {
          ...solMetadata.tags,
        },
      };
      hubble.trackEvent('recommended_jobs_displayed', {
        solMetadata: enhancedSolMetaData,
        currentPage: page,
      });
    }
  }, [
    environment,
    isFilteredOnNew,
    page,
    solMetadata,
    hubble,
    tracked,
    setTracked,
  ]);
};

export default useHubbleTrackDisplayEvent;
